<template lang="pug">
.register-section-main-wrapper(:class='"context-" + context')
  include RegisterSection.pug
</template>

<script>
import { mapState } from 'vuex'
import AlreadyRegistered from '@/components/register/AlreadyRegistered'

export default {
  name: 'RegisterSection',
  components: { AlreadyRegistered },
  computed: mapState(['context']),
  data() {
    return {
      type: '',
      registerEnabled: true,
    }
  },
  created() {
    this.type = this.$route.params.type
  },
}
</script>

<style scoped lang="scss">
@import './../../variables';
@import './../../variables_colreps';
@import './../../variables_mexreps';
@import 'RegisterSection';

.context-colreps {
  @import 'RegisterSectionColreps';
}
.context-mexreps {
  @import 'RegisterSectionMexreps';
}
</style>



// WEBPACK FOOTER //
// src/components/register/RegisterSection.vue